/**
 * Shared agreement schemas and types.
 *
 * Extracted to a leaf file (no `fetchApi` import) so other networking files
 * such as `networking/carts.api.ts` can reuse `agreementSchema` without
 * forming a cycle through `lib/api-helpers.ts`.
 */
import { z } from "zod";

export const agreementSchema = z.object({
  id: z.number(),
  required: z.boolean(),
  show_path: z.string(),
  title: z.string(),
  show_at_checkout: z.boolean(),
  default_checked: z.boolean(),
});

export const agreementsResponseSchema = z.object({
  agreement: agreementSchema.extend({
    description: z.string(),
    language_iso: z.string(),
    company_logo: z.string(),
  }),
  meta: z.object({
    request_id: z.string(),
    timestamp: z.string(),
  }),
});

export type Agreement = z.infer<typeof agreementSchema>;
